import React, { Fragment } from 'react';
import { arrayOf, func, shape } from 'prop-types';

// utils
import { useUserRolePermissions } from 'hooks';
import { AUTH_SEQUENCING_ALL_DONE } from 'feature/loading-management/utils/const';

// Components
import { Box, Button, Chip, Divider, Tooltip, Typography } from '@mui/material';
import DoneAllRoundedIcon from '@mui/icons-material/DoneAllRounded';
import EmptyState from './EmptyState';

const Unsequenced = props => {
  const { unsequencedAuthorizations, badgeProps, onRemoveSeq } = props;
  const { isProductLoadingManage } = useUserRolePermissions();

  return (
    <Box color="primary.dark" pt={3} px={3}>
      <Typography color="inherit" sx={{ pb: 1 }} variant="subtitle1">
        Not Sequenced
      </Typography>
      <Divider />
      {!unsequencedAuthorizations.length ? (
        <Box pt={1.5}>
          <EmptyState
            icon={<DoneAllRoundedIcon sx={{ fontSize: 32 }} />}
            text={AUTH_SEQUENCING_ALL_DONE}
            type="DONE_ALL_ROUNDED"
          />
        </Box>
      ) : (
        unsequencedAuthorizations.map(
          ({ active, inventoryOwner, productAuthorizationId, supplierDirectedBlend }, idx) => {
            const currentBadgeProps = badgeProps(active, inventoryOwner, supplierDirectedBlend);
            return (
              <Fragment
                key={`unsequenced-${productAuthorizationId}${supplierDirectedBlend ? '-SDB' : ''}`}
              >
                <Box alignItems="center" display="flex" justifyContent="space-between" py={1.5}>
                  <Box display="flex" justifyContent="space-between">
                    <Tooltip
                      enterTouchDelay={10}
                      {...currentBadgeProps?.tooltipProps}
                      title={currentBadgeProps?.title}
                    >
                      <Chip
                        label={currentBadgeProps?.tag}
                        type={currentBadgeProps?.type}
                        variant="badge"
                      />
                    </Tooltip>
                    <Typography color="textPrimary" sx={{ pl: 1 }} variant="body2">
                      {supplierDirectedBlend ? 'Supplier Directed Blend' : inventoryOwner.nameShort}
                    </Typography>
                  </Box>
                  {isProductLoadingManage && (
                    <Button onClick={() => onRemoveSeq(idx)} variant="outlined">
                      Sequence
                    </Button>
                  )}
                </Box>
                <Divider />
              </Fragment>
            );
          }
        )
      )}
    </Box>
  );
};

export default Unsequenced;

Unsequenced.propTypes = {
  badgeProps: func.isRequired,
  onRemoveSeq: func.isRequired,
  unsequencedAuthorizations: arrayOf(shape({})),
};

Unsequenced.defaultProps = {
  unsequencedAuthorizations: [],
};
